<footer class="border-top bg-body-tertiary py-3 text-center text-body-secondary small">
  © 2026 CUN Intelligence Business
</footer>
